import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  SimpleChanges,
} from "@angular/core";
import { TicketService } from "../../services/ticket.service";

@Component({
  selector: "app-workflow-history",
  templateUrl: "./workflow-history.component.html",
  styleUrls: ["./workflow-history.component.scss"],
})
export class WorkflowHistoryComponent implements OnChanges, AfterViewInit {
  @Input()
  ticketId: number;

  @Input()
  hideDraftStatus: boolean;

  @Input()
  refresh: EventEmitter<string>;

  history: Array<any>;

  constructor(private service: TicketService) {}

  ngAfterViewInit() {
    if (this.refresh) {
      this.refresh.subscribe(() => this.getHistory());
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes) {
      if (
        changes.ticketId &&
        changes.ticketId.currentValue !== changes.ticketId.previousValue
      ) {
        this.getHistory();
      }
    } else {
      this.history = [];
    }
  }

  /**
   * @description Call get workflow history from API service
   */
  getHistory(): void {
    if (this.ticketId > 0) {
      this.service.getHistory(this.ticketId).subscribe((history) => {
        this.history = history;
      });
    } else {
      this.history = [];
    }
  }
}
